module.exports = "/images/signal.svg?fed9b2c7f7c6108d60f7830018ef3285";